// extracted by mini-css-extract-plugin
export default {"form":"mealItemForm_form__ttp0t"};